import React from 'react';
import { createForm } from 'rc-form';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import get from 'lodash/get';
import map from 'lodash/map';
import forEach from 'lodash/forEach';
import find from 'lodash/find';

import axios from 'utils/axios';
import Text from 'ui/Text';
import Button from 'ui/Button';
import FieldProcessor from 'components/BaseQuestionnaire/FieldProcessor';
import Auth from 'shared/Auth';
import { SavingSubject } from 'shared/SavingSubject';
import { FileSaveSubject } from 'shared/FileSaveSubject';
import { ControlPassSubject } from 'shared/ControlPassSubject';
import { LayoutSubject } from 'shared/LayoutSubject';
import { AuthSubject } from 'shared/AuthSubject';
import { QuestionnaireSubject } from 'shared/QuestionnaireSubject';
import localStorage from 'utils/localStorage';
import {
  PROFILE_KEY,
  QUESTIONS_KEY,
  STAGE_TYPE_KEY,
  PREVIOUS_STAGE_KEY,
  FLASH_MESSAGE_KEY,
} from 'utils/app-constants';
import { CDRComponentMap } from '../CDRSections/CDRComponentMap';
import PageNotFound from 'shared/PageNotFound';

let fileItem = '';
let processQue = [];
let timeout;
let selectedFields;
let activeControlType;

class FormLayout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      questions: this.props.questions || [],
      saving: false,
      statusMessage: 'Saving...',
      errorMessage: '',
      cdrScores: [],
      newRowValue: 5,
      surveyMode: Auth.isSurveyMode(),
    };

    this.subscription = null;
    this.savingSubjectListener = null;
    this.fileSaveListener = null;
    this.controlPassListener = null;
  }

  componentDidMount() {
    this.savingSubjectListener = SavingSubject.subscribe(newState => {
      this.setState({ ...newState });
    });

    this.fileSaveListener = FileSaveSubject.subscribe(file => {
      fileItem = file;
    });

    this.controlPassListener = ControlPassSubject.subscribe(controlPass => {
      activeControlType = get(controlPass, 'controlType');

      selectedFields = get(controlPass, 'field');
    });
  }

  componentWillReceiveProps(newProps) {
    const newQuestions = newProps.questions;

    this.updateQuestions(newQuestions);
  }

  componentWillUnmount() {
    if (this.savingSubjectListener !== null) {
      this.savingSubjectListener.unsubscribe();
      this.savingSubjectListener = null;
    }

    if (this.fileSaveListener !== null) {
      this.fileSaveListener.unsubscribe();
      this.fileSaveListener = null;
    }
  }

  saveAndContinue = () => {
    this.props.history.push('/login');
    Auth.logout();
  };

  goToAHomePage = activeRoute => {
    LayoutSubject.next({ activeRoute, showHome: true });
  };

  updateQuestions = questions => {
    this.setState({ questions });
  };

  goToNextpage = () => {
    this.props.history.push(`/section/${this.props.nextSectionId}`);
  };

  addRow = tableRows => {
    this.setState({
      newRowValue: ++tableRows,
    });
  };

  completeApplication = () => {
    let payload = {
      user_id: get(Auth.getUser(), 'id'),
      dry_run: false,
    };

    this.setState({ errorMessage: '' });

    SavingSubject.next({
      saving: true,
      statusMessage: 'Completing the application...',
    });

    axios
      .post(`/stage/${get(Auth.getUser(), 'current_stage_id')}/complete`, payload)
      .then(response => {
        SavingSubject.next({ saving: false });
        const user = Auth.getUser();

        const langMap = {
          en_US: 'en',
          fr_FR: 'fr',
        };

        const userLang = get(user, 'locale');
        let isError = get(response.data, 'status.status');

        if (isError === 'fail') {
          this.setState({
            errorMessage: get(
              response.data,
              'status.message',
              'You have successfully completed your application '
            ),
          });
          return;
        }
        axios.get(`/user/${get(Auth.getUser(), 'id')}`).then(res => {
          const { returned_resultset } = get(res, 'data');
          let currentStageId = get(returned_resultset[0], 'current_stage_id');
          let previousStageId = localStorage.getItem(PREVIOUS_STAGE_KEY);
          let previousQuestions = axios.get(`/stage/${previousStageId}`).then(response => {
            return {
              stage_id: previousStageId,
              questions: get(response.data, 'returned_resultset[0].forms'),
            };
          });

          let currentQuestions = axios
            .get(`/stage/${get(returned_resultset[0], 'current_stage_id')}`)
            .then(response => {
              return {
                stage_id: get(returned_resultset[0], 'current_stage_id'),
                stage_type: get(
                  response.data,
                  'returned_resultset[0].stage_type',
                  ''
                ).toLocaleLowerCase(),
                questions: get(response.data, 'returned_resultset[0].forms'),
              };
            });
          Promise.all([previousQuestions, currentQuestions])
            .then(responses => {
              this.setState({ cdrMode: true });

              localStorage.saveItem(STAGE_TYPE_KEY, get(responses[1], 'stage_type'));

              localStorage.saveList(QUESTIONS_KEY, get(responses[0], 'questions'));

              localStorage.saveList(get(responses[0], 'stage_id'), get(responses[0], 'questions'));
              localStorage.saveList(get(responses[1], 'stage_id'), get(responses[1], 'questions'));
              localStorage.removeItem(FLASH_MESSAGE_KEY);

              AuthSubject.next({
                profile: true,
                locale: {
                  lang: userLang,
                  local_locale: get(langMap, userLang),
                },
              });
              QuestionnaireSubject.next();
              this.props.history.push('/section/5b7a91a6ff26');
              // LayoutSubject.next({ activeRoute: '/', showHome: false });
              window.location.reload();
            })
            .catch(error => {
              localStorage.removeItem(PROFILE_KEY);

              this.setState({
                loading: false,
                errorMessage:
                  get(error, 'response.data.message') ||
                  'Could not proceed. There was an issue retrieveing the questions.',
              });
            });
        });
      })
      .catch(error => {
        this.setState({ errorMessage: 'Problem transitioning you to the CDR.' });
        SavingSubject.next({ saving: false });
      });
  };

  onSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(error => {
      if (!error) {
        this.props.history.push(`/section/${this.props.nextSectionId}`);
      }
    });
  };

  processQuestion = (questionDef, index, parentLink = false) => {
    const questions = get(questionDef, 'questions');

    const baseQuestion =
      get(questionDef, 'question_type') === 'multiple_questions' ? (
        <div key={`${index}-${get(questionDef, this.props.titleKey)}`}>
          {parentLink ? (
            <Text modifiers="question-title primary-blue">
              {' '}
              {get(questionDef, this.props.titleKey)}
            </Text>
          ) : (
            <li className={`question-list__item__question ${get(questionDef, 'question_type')}`}>
              <Text>
                {' '}
                {get(questionDef, this.props.titleKey)}
                <span className="primary-orange">
                  {get(questionDef, 'is_mandatory') ? '*' : null}
                </span>
              </Text>
            </li>
          )}
          <ol className={`question-list ${get(questionDef, 'question_type')}`}>
            {questions.map((questionItem, qnIndex) => this.processQuestion(questionItem, qnIndex))}
          </ol>
        </div>
      ) : (
        <li
          className="question-list__item"
          key={`${index}-${get(questionDef, this.props.titleKey)}`}>
          <div className="question-list__item__question">
            <Text>
              {get(questionDef, this.props.titleKey)}
              <span className="primary-orange">
                {get(questionDef, 'is_mandatory') ? '*' : null}
              </span>
            </Text>
          </div>
          {questions && questions.length ? (
            questions.map((questionItem, qnIndex) => this.processQuestion(questionItem, qnIndex))
          ) : (
            <FieldProcessor
              titleKey={this.props.titleKey}
              valueKey={this.props.valueKey}
              responses={this.props.responses}
              question={questionDef}
              form={this.props.form}
              addRow={this.addRow}
              newRowValue={this.state.newRowValue}
            />
          )}
        </li>
      );

    return baseQuestion;
  };

  render() {
    const sectionQuestionnaire = Auth.getQuestions();

    let currentStage = get(Auth.getUser(), 'current_stage_id');
    let previousStage = localStorage.getItem(PREVIOUS_STAGE_KEY);

    const surveryStageExplanation =
      currentStage === previousStage ? (
        <div className="intro-banner">
          <Text type="explanation" modifiers="heavy primary-orange full-width">
            <FormattedMessage
              id="Welcome.Explanation"
              defaultMessage={`Welcome to the African CSO Platform`}
            />
          </Text>
          <ul className="dashed-list">
            {get(Auth.getUser(), 'awards_user_id') && (
              <li>
                <span>
                  <Text type="small-bold" modifiers="small2">
                    <FormattedMessage
                      id="Welcome.Explanation.Point.0"
                      defaultMessage="Thank you for your registration. We notice that you were a previous applicant to the African CSO Excellence Awards. As a result, you can download your answers from your past application and verify which information needs to be changed or updated to complete the Economic Justice Survey."
                    />
                  </Text>
                </span>
              </li>
            )}
            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.1"
                  defaultMessage="The questions are not mandatory but answering as many as possible will help you to score higher on the Capacity Diagnostic Report and give a more accurate picture of your organization’s effectiveness."
                />
              </span>
            </li>
            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.2"
                  defaultMessage="All the information you provide, including the documents submitted will be kept strictly confidential. For more details on our data protection policy, {link}"
                  values={{
                    link: (
                      <Link to={`/data-protection-policy`} target="_blank">
                        <Text type="small-bold" modifiers="primary-orange small2">
                          <FormattedMessage id="link" defaultMessage="please click here" />
                        </Text>
                      </Link>
                    ),
                  }}
                />
              </span>
            </li>
            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.4"
                  defaultMessage="You can navigate in the questionnaire using the menu on the left."
                />
              </span>
            </li>
            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.3"
                  defaultMessage="All uploaded documents must be in PDF or Word formats."
                />
              </span>
            </li>
            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.6"
                  defaultMessage="The questionnaire is also an opportunity for your team to reflect upon your organisational strengths, we recommend that you involve different members of your team."
                />
              </span>
            </li>

            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.7"
                  defaultMessage="Please note that you cannot change your answers after submitting the survey. However, your entries are automatically saved while you complete the survey, so you can return at a later time to finalize and submit it."
                />
              </span>
            </li>
          </ul>
          <Link
            to={`/section/${get(sectionQuestionnaire[0], 'id', '')}`}
            className="btn btn-primary inline">
            <Text type="small">
              <FormattedMessage id="Questionnaire.Start" defaultMessage="Start" />
            </Text>
          </Link>
        </div>
      ) : (
        <div className="intro-banner">
          <Text type="explanation" modifiers="heavy primary-orange full-width">
            <FormattedMessage
              id="Welcome.Explanation"
              defaultMessage={`Welcome to the African CSO Platform`}
            />
          </Text>
          <ul className="dashed-list">
            {get(Auth.getUser(), 'awards_user_id') && (
              <li>
                <span>
                  <Text type="small-bold" modifiers="small2">
                    <FormattedMessage
                      id="Welcome.Explanation.Point.0"
                      defaultMessage="Thank you for your registration. We notice that you were a previous applicant to the African CSO Excellence Awards. As a result, you can download your answers from your past application and verify which information needs to be changed or updated to complete the Economic Justice Survey."
                    />
                  </Text>
                </span>
              </li>
            )}
            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.1"
                  defaultMessage="The questions are not mandatory but answering as many as possible will help you to score higher on the Capacity Diagnostic Report and give a more accurate picture of your organization’s effectiveness."
                />
              </span>
            </li>
            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.2"
                  defaultMessage="All the information you provide, including the documents submitted will be kept strictly confidential. For more details on our data protection policy, {link}"
                  values={{
                    link: (
                      <Link to={`/data-protection-policy`} target="_blank">
                        <Text type="small-bold" modifiers="primary-orange small2">
                          <FormattedMessage id="link" defaultMessage="please click here" />
                        </Text>
                      </Link>
                    ),
                  }}
                />
              </span>
            </li>
            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.4"
                  defaultMessage="You can navigate in the questionnaire using the menu on the left."
                />
              </span>
            </li>
            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.3"
                  defaultMessage="All uploaded documents must be in PDF or Word formats."
                />
              </span>
            </li>
            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.6"
                  defaultMessage="The questionnaire is also an opportunity for your team to reflect upon your organisational strengths, we recommend that you involve different members of your team."
                />
              </span>
            </li>

            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.7"
                  defaultMessage="Please note that you cannot change your answers after submitting the survey. However, your entries are automatically saved while you complete the survey, so you can return at a later time to finalize and submit it."
                />
              </span>
            </li>
          </ul>
          <Link to={`/section/${this.props.nextSectionId}`} className="btn btn-primary inline">
            <Text type="small">
              <FormattedMessage id="Questionnaire.Start" defaultMessage="Start" />
            </Text>
          </Link>
        </div>
      );

    if (this.props.sectionIndex === -1 && this.state.surveyMode) {
      return surveryStageExplanation;
    } else if (!this.state.surveyMode) {
      let CdrComponent = get(
        find(CDRComponentMap, ['route', this.props.match.params.id]),
        'component'
      );

      if (!CdrComponent) {
        return <PageNotFound />;
      }

      const nextBtn = this.props.nextSectionId ? (
        <Button onClick={this.goToNextpage} nature="primary" type="button">
          <Text type="small">
            <FormattedMessage id="Questionnaire.Next" defaultMessage="Next" />
          </Text>
        </Button>
      ) : null;

      return (
        <div>
          <CdrComponent />
          <div className="row cdr-next-btn">{nextBtn}</div>
        </div>
      );
    }

    const { saving, statusMessage } = this.state;

    let questionFields;

    if (this.props.sectionIndex !== -1) {
      questionFields = this.state.questions.map((questionDef, index) =>
        this.processQuestion(questionDef, index, true)
      );
    }

    return (
      <section>
        {saving ? (
          <Text type="small-semi-bold" modifiers="saving-indicator ">
            {statusMessage || 'Saving...'}
          </Text>
        ) : null}
        {this.state.errorMessage ? (
          <Text type="small" modifiers="mandatory-explanation alert">
            {this.state.errorMessage}
          </Text>
        ) : null}
        <form onSubmit={this.onSubmit} className="form">
          <ol className="question-list">{questionFields}</ol>
          <div className="action-bar clearfix">
            {this.props.nextSectionId ? (
              <div>
                <Button nature="primary" type="submit">
                  <Text type="small">
                    <FormattedMessage id="Questionnaire.Proceed" defaultMessage="Proceed" />
                  </Text>
                </Button>
                <Button onClick={this.saveAndContinue} nature="default" type="button">
                  <Text type="small">
                    <FormattedMessage
                      id="Questionnaire.SaveAndComeBackLater"
                      defaultMessage="Save and come back later"
                    />
                  </Text>
                </Button>
              </div>
            ) : null}
            {!this.props.nextSectionId && sectionQuestionnaire.length ? (
              <Button nature="primary" onClick={this.completeApplication} type="button">
                <Text type="small">
                  <FormattedMessage
                    id="Questionnaire.CompleteApplication"
                    defaultMessage="Submit survey"
                  />
                </Text>
              </Button>
            ) : null}
          </div>
        </form>
      </section>
    );
  }
}

const WrappedForm = createForm({
  onValuesChange(_, changedValues, allValues) {
    SavingSubject.next({ saving: true });

    console.log(changedValues, allValues);

    if (timeout) clearTimeout(timeout);

    const handleProcessing = () => {
      const formId = get(_, 'questions[0].form_id', '');

      const getKey = Object.keys(changedValues);

      const questionId = getKey[0];

      let currentValue;

      switch (activeControlType) {
        case 'checkbox':
          currentValue = selectedFields;
          break;
        case 'radio':
          currentValue = selectedFields;
          break;
        default:
          currentValue = get(allValues, questionId);
          break;
      }

      // reset the global control
      activeControlType = '';

      const response = get(_.responses, getKey);

      const multiInput = (response && Object.keys(response)) || [];

      if (response && response.splice && response.length > 1) {
        currentValue = map(currentValue, (valueProp, index) => {
          const rowKeys = Object.keys(currentValue[0]);

          const row = response[index] || {};

          const newValue = {};

          forEach(rowKeys, key => {
            newValue[key] = currentValue[index][key] || row[key];
          });

          return newValue;
        });
      }

      if (multiInput && multiInput.length && typeof response !== 'string') {
        const allKeys = Object.keys(currentValue);

        forEach(allKeys, key => {
          currentValue[key] = currentValue[key] || response[key];
        });
      }

      const stringifiedValue = JSON.stringify(currentValue);

      let payload = {
        form_id: formId,
        user_id: get(Auth.getUser(), 'id'),
        response: stringifiedValue,
      };

      if (fileItem) {
        const data = new FormData();

        data.append('response_file', get(fileItem, 'fileItem'));

        data.append('response', get(fileItem, 'fieldId'));

        data.append('form_id', formId);

        data.append('user_id', get(Auth.getUser(), 'id'));

        payload = data;

        fileItem = '';
      }

      axios
        .post(`/question/${questionId}/response`, payload)
        .then(() => {
          SavingSubject.next({ saving: false });
        })
        .catch(error => {
          SavingSubject.next({
            saving: true,
            statusMessage: get(error, 'response.data.message') || error,
          });
        });
    };

    processQue.push(handleProcessing);

    timeout = setTimeout(() => {
      processQue[processQue.length - 1]();
      processQue = [];
    }, 600);
  },
})(FormLayout);

export default WrappedForm;



// WEBPACK FOOTER //
// ./src/components/BaseQuestionnaire/FormLayout.js